import React from 'react'
import { Link } from 'gatsby'
import Img from '@/lib/Img'
import NoImg from '@/lib/NoImg'
import highlight from '@/utils/highlight'

const ArticlePreviewSm = ({ title, metaInfo, featuredImage, query }) => {
	const url = '/blog/' + metaInfo?.slug.current

	return (
		<article className="group">
			<Link className="grid grid-cols-[auto,1fr] gap-4 items-center" to={url}>
				<figure className="w-[60px] h-[3em]">
					{featuredImage
						? <Img image={featuredImage} />
						: <NoImg />
					}
				</figure>

				<h2
					className="h5 line-clamp group-hover:text-orange"
					style={{ '--lines': 2 }}
					dangerouslySetInnerHTML={{ __html: highlight(title, query) }}
				/>
			</Link>
		</article>
	)
}

export default ArticlePreviewSm
